export default "__VITE_ASSET__DPVGqAn0__"